import * as React from "react";
const SvgWhatshot = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M9.49268 3.64629C9.49268 2.21296 8.99935 0.446289 8.99935 0.446289C11.606 2.53296 13.3327 5.73962 13.3327 9.33296C13.3327 12.2796 10.946 14.6663 7.99935 14.6663C5.05268 14.6663 2.66602 12.2796 2.66602 9.33296C2.66602 7.07962 3.47268 5.00629 4.81935 3.40629L4.79935 3.64629C4.79935 5.01962 5.83935 6.13296 7.21935 6.13296C8.59268 6.13296 9.49268 5.01962 9.49268 3.64629ZM5.65935 10.573C5.65935 11.733 6.61935 12.6663 7.80602 12.6663C9.57268 12.6663 11.006 11.233 11.006 9.46629C11.006 8.53962 10.8727 7.63296 10.6127 6.77296C9.93268 7.68629 8.71268 8.25296 7.53268 8.49296C6.35935 8.73296 5.65935 9.49296 5.65935 10.573Z",
	fill: "currentColor"
}));
export default SvgWhatshot;
